'use client';

import { Alert, Button } from '@/components';
import { ROUTES } from '@/types/enums';

import { RECOVERY_MESSAGES } from '../../constants';

type RecoveryErrorProps = {
  message?: string | null;
  onRetry: () => void;
  onBackToLogin: () => void;
};

export const RecoveryError = ({
  message,
  onRetry,
  onBackToLogin,
}: RecoveryErrorProps) => {
  return (
    <div className="flex flex-col gap-5 p-2 text-center">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Não foi desta vez</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Revise o processo e tente novamente em instantes.
        </p>
      </div>

      <Alert
        variant="error"
        title="Falha na verificação"
        description={message || RECOVERY_MESSAGES.KYC_FAILED}
      />

      <Button
        type="button"
        variant="secondary"
        size="large"
        className="h-12 w-full text-base"
        onClick={onRetry}
      >
        Tentar novamente
      </Button>

      <Button type="button" variant="link" className="mx-auto" onClick={onBackToLogin}>
        Voltar ao login
      </Button>

      <a
        href={ROUTES.Enum['/suporte']}
        className="text-sm font-medium text-secondary-text underline underline-offset-4"
      >
        Falar com o suporte
      </a>
    </div>
  );
};
